import MessageTemplatesPageView from "./MessageTemplatesPageView";

function MessageTemplatesPage() {
  return <MessageTemplatesPageView />;
}

export default MessageTemplatesPage;
